import { MessageCircle } from "lucide-react";
import { useSiteContent } from "@/context/SiteContentContext";

// Accepts either a full wa.me URL or a plain phone number from site content,
// The Footer Support WhatsApp number (footer.support_whatsapp) is the source of truth;
// contact.whatsapp is only a fallback.
function toWaLink(v) {
  const val = (v || "").trim();
  if (/^https?:\/\//i.test(val)) return val;
  const digits = val.replace(/\D/g, "");
  return digits ? `https://wa.me/${digits}` : "https://wa.me/917990391645";
}

export default function WhatsAppFloat() {
  const { t } = useSiteContent();
  const href = toWaLink(t("footer.support_whatsapp", "") || t("contact.whatsapp", ""));
  return (
    <a href={href} target="_blank" rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 left-6 z-40 h-12 w-12 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-xl flex items-center justify-center transition-transform hover:scale-105"
      aria-label="Chat on WhatsApp">
      <MessageCircle className="h-5 w-5" />
    </a>
  );
}
